/* Anemoia — product page behaviour.
   1. Shipping estimator: pick a country, get the cost in the visitor's own
      currency plus a delivery window.
   2. Description collapse.
   3. Relocation of two elements that other scripts position, so Liquid cannot:
        .aask     — Ask-about-this-piece chips, injected after .product-form
        .avr-slot — reviews, moved into the media column at tablet+
      "Fits best to" goes immediately above the chips; Material Note under reviews. */
(function () {
  'use strict';

  /* Shipping numbers live in ONE place: snippets/av-shipping-data.liquid, printed onto the page as
     <script type="application/json" id="av-ship-data">. Nothing in this file is a copy of them. If the
     block is missing, the estimator falls back to the worldwide row below rather than showing nothing. */
  var DATA = { dispatch: { lo: 1, hi: 3 }, zones: [], blocked: ['RU', 'BY'], 'default': { fee: 18, free: 250, lo: 7, hi: 14, duty: 'row' } };
  try {
    var dataEl = document.getElementById('av-ship-data');
    if (dataEl) DATA = JSON.parse(dataEl.textContent);
  } catch (e) {}

  function zone(c) {
    if (DATA.blocked.indexOf(c) > -1) return { blocked: true };
    for (var i = 0; i < DATA.zones.length; i++) if (DATA.zones[i].c.indexOf(c) > -1) return DATA.zones[i];
    return DATA['default'];
  }

  /* Import duty differs by destination, so the row says which case applies. The wording states who sets it
     and whose responsibility it is, and leaves the detail to the shipping policy. It is said once,
     here, and never in the cart or at checkout. */
  var DUTY_US  = 'Import duty prepaid. Orders to the United States ship by tracked priority delivery, with US import duty paid in advance at dispatch through Zonos, a US customs duty-prepayment service. Zonos states that recipients are not asked to pay duties on delivery. <a href="/pages/faq">How it works</a>';
  var DUTY_US_HIGH = 'For pieces valued over $2,500, US import duty is assessed on arrival and remains the buyer\'s responsibility. Write to us before ordering and we will confirm the cost.';
  var DUTY_EU  = 'Your order moves within the EU customs union, so there are no import duties or customs formalities on arrival.';
  var DUTY_ROW = 'Any import duty or tax is set by the destination country and remains the recipient\'s responsibility. We do not calculate it, so it is not part of the price or shipping shown here. Your local customs office can confirm what applies.';
  var BLOCKED  = 'Due to EU sanctions in force since 2022, we can\'t ship to this country through checkout. Write to us through the chat or our <a href="/pages/contact">contact form</a>.';
  function dutyText(z) {
    if (z.blocked) return BLOCKED;
    if (z.duty === 'us') {
      /* Zonos prepayment covers postal parcels under USD 2,500 only. data-price is in the shopper's currency (cents). */
      var r = document.querySelector('[data-av-est]'), p = r ? parseInt(r.getAttribute('data-price') || '0', 10) / 100 : 0,
          c = r ? (r.getAttribute('data-cur') || 'EUR') : 'EUR', lim = c === 'USD' ? 2500 : 1850;
      return p >= lim ? DUTY_US_HIGH : DUTY_US;
    }
    return z.duty === 'eu' ? DUTY_EU : DUTY_ROW;
  }

  function addBiz(d, n) {
    var x = new Date(d.getTime()), a = 0;
    while (a < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) a++; }
    return x;
  }
  var MON = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ');
  function fmtRange(a, b) {
    if (a.getMonth() === b.getMonth()) return a.getDate() + '–' + b.getDate() + ' ' + MON[b.getMonth()];
    return a.getDate() + ' ' + MON[a.getMonth()] + ' – ' + b.getDate() + ' ' + MON[b.getMonth()];
  }

  function estimator() {
    var root = document.querySelector('[data-av-est]');
    if (!root || root.dataset.avReady) return;
    root.dataset.avReady = '1';
    var sel  = root.querySelector('[data-av-country]'),
        cost = root.querySelector('[data-av-cost]'),
        eta  = root.querySelector('[data-av-eta]'),
        duty = root.querySelector('[data-av-duty]');
    if (!sel || !cost || !eta) return;

    var cur  = root.getAttribute('data-cur') || 'EUR';
    var pres = parseInt(root.getAttribute('data-price') || '0', 10) / 100;
    var eur  = (cur === 'EUR') ? pres : null;
    /* Shopify's own exchange rate (no market price uplift in it). Since 28 Oct 2026 US prices carry +20%
       for prepaid duty, so the garment's price can no longer be used to derive the rate. */
    var shopRate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    var rate = (cur === 'EUR') ? 1 : (shopRate > 0 ? shopRate : null);

    /* Shipping rates are set in euro, but Markets shows the visitor local money.
       Rather than invent an exchange rate, derive Shopify's own: the same garment
       priced in euro (asked for via the Greek market) against its presented price. */
    function money(eurAmount) {
      if (rate === null || cur === 'EUR') return '€' + eurAmount;
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency', currency: cur, maximumFractionDigits: 0
        }).format(eurAmount * rate);
      } catch (e) { return '€' + eurAmount; }
    }

    function render() {
      var z = zone(sel.value);
      var note = root.querySelector('[data-av-note]');
      if (z.blocked) {
        cost.innerHTML = '<b>Not available at checkout</b>';
        eta.textContent = '\u2014';
        if (duty) duty.innerHTML = dutyText(z);
        if (note) note.textContent = '';
      } else {
        var onUs = z.fee === 0 || (eur !== null && z.free > 0 && eur >= z.free);
        if (onUs)            cost.innerHTML = '<b>On us</b>';
        else if (z.free > 0) cost.innerHTML = '<b>' + money(z.fee) + '</b> \u00b7 on us over ' + money(z.free);
        else                 cost.innerHTML = '<b>' + money(z.fee) + '</b>';
        if (duty) duty.innerHTML = dutyText(z);
        var now = new Date();
        // Expected window: counted from the last dispatch day, so the range stays tight; pieces that
        // leave sooner simply arrive at the early end or before it.
        eta.textContent = fmtRange(addBiz(now, DATA.dispatch.hi + z.lo), addBiz(now, DATA.dispatch.hi + z.hi));
        if (note) {
          var t = 'Dates include preparation by hand.';
          if (z.duty !== 'eu') t += ' Outside the EU, customs clearance can add a few days.';
          if (sel.value === 'US' && root.getAttribute('data-fur') === 'true')
            t += ' Fur shipped to the USA is inspected by US Fish & Wildlife on arrival and may need up to a week longer.';
          note.textContent = t;
        }
      }
      try { localStorage.setItem('av_ship_country', sel.value); } catch (e) {}
    }

    if (rate === null && eur === null && window.fetch) {
      var pu = root.getAttribute('data-purl');
      if (pu) {
        fetch(pu + '.js?country=GR')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.price) {
              eur = d.price / 100;
              if (eur > 0) rate = pres / eur;
              render();
            }
          })
          .catch(function () {});
      }
    }
    try {
      var saved = localStorage.getItem('av_ship_country');
      if (saved) for (var i = 0; i < sel.options.length; i++)
        if (sel.options[i].value === saved) { sel.selectedIndex = i; break; }
    } catch (e) {}
    sel.addEventListener('change', render);
    render();
  }

  function collapse() {
    var w = document.querySelector('[data-av-desc]');
    if (!w || w.dataset.avReady) return;
    var inner = w.querySelector('[data-av-desc-inner]'), btn = w.querySelector('[data-av-desc-btn]');
    if (!inner || !btn) return;
    w.dataset.avReady = '1';
    var CAP = 132, opened = false, lastW = window.innerWidth;

    function measure() {
      /* Once the reader has opened it, never close it again. On a phone the
         address bar hides on scroll, which fires resize — re-measuring there
         was snapping the description shut mid-read while the button still
         said "Show less". */
      if (opened) return;
      if (inner.scrollHeight > CAP + 40) { w.classList.add('is-collapsed'); btn.hidden = false; }
      else { w.classList.remove('is-collapsed'); btn.hidden = true; }
    }
    btn.addEventListener('click', function () {
      opened = w.classList.toggle('is-collapsed') === false;
      btn.setAttribute('aria-expanded', opened ? 'true' : 'false');
      btn.textContent = opened ? 'Show less' : 'Learn more about this item';
      if (!opened) w.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
    measure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    /* Width-only: ignore the height changes a scrolling mobile browser produces. */
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      measure();
    });
  }

  function place() {
    var fit = document.querySelector('[data-av-fit]'), aask = document.querySelector('.aask');
    if (fit && aask && fit.nextElementSibling !== aask) aask.parentNode.insertBefore(fit, aask);
    var story = document.querySelector('.av-storylink'), avr = document.querySelector('.avr-slot');
    if (story && avr && story.parentNode !== avr) avr.appendChild(story);
  }

  function run() { estimator(); collapse(); place(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  var tries = 0, t = setInterval(function () { run(); if (++tries > 40) clearInterval(t); }, 150);
  if (window.MutationObserver) {
    var mo = new MutationObserver(place);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 8000);
  }
})();